<script>
export default {
  name: "FInputLongText" ,
  props: ['options', 'item']
}
</script>

<template>
<div class="form-group">
  <label>{{options.label}}  </label>
  <textarea class="form-control" v-model="item[options.codename]"></textarea>
</div>
</template>

<style scoped>

</style>